export const menuScrollableStyle = {
  maxWidth: 700,
  overflow: "auto",
  display: "grid",
  "& li": {
    outline: 0,
  },
};
